import { HashRouter } from 'react-router-dom';
import { createHashHistory } from 'history';

export const history = createHashHistory();

export default class CallableHashRouter extends HashRouter {
  history;
}